// @flow

import React, { Component } from 'react';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import ActionLanguage from 'material-ui/svg-icons/action/language';
import ImageStraighten from 'material-ui/svg-icons/image/straighten';
import DeviceSignalCellularNull from 'material-ui/svg-icons/device/signal-cellular-null';
import ImageColorize from 'material-ui/svg-icons/image/colorize';
import {Icon} from 'react-fa';
import _ from 'lodash';
import $ from 'jquery';

import type {JQuery} from 'jquery';

import Map from './Map.jsx';
import App from './App.jsx';

import {round6, dec6, proporcion, takeDir, takeFilename, no_rclick, gen_snum, invertColor, no_parens} from './utils.js';
import {get_tif_pixel} from './fetch_things.js';
import {load_stats} from './show_stats.js';
import {SIDEBAR_WIDTH} from './consts.js';

import type {T_LL, T_Bounds, T_Next} from './types.js';

import './css/Medidas.css';

const S = require('underscore.string');

const utm = require('utm');



type T_MedidasProps = {
  width         : number,
  show_tree     : boolean,
  num_decimals  : number,
  hide          : boolean,
  use_pixel_tool: boolean,
  app           : App
};


type T_MedidasState = {
  m_lat  : string,
  m_lon  : string,
  m_value: number,
  m_units: string,
  m_color: string,
  m_dist : number,
  m_area : number,
  usage  : string,
  pos_x  : number,
  active : boolean
};


type T_Title = {
  title: string
};



export default class Medidas extends Component<T_MedidasProps, T_MedidasState> {
  drawing_listener: ?Object;
  drawingManager  : ?Object;
  tool_ov         : ?Object;
  raw_stop_bt     : JQuery;
  j_stop          : JQuery;
  j_coord         : JQuery;
  j_dist          : JQuery;
  j_area          : JQuery;
  
  clean_tool     : (state_too: boolean, show_usage?: boolean) => void;
  fix_draw_titles: () => void;
  set_position   : () => void;
  stop_drawing   : () => void;
  activate_tool  : (next?: T_Next) => void;
  close          : () => void;
  hide           : () => void;

  
  
  
  constructor(props: T_MedidasProps) {
    super(props);
    
    this.state = {
      m_lat  : '',
      m_lon  : '',
      m_value: 0,
      m_units: '',
      m_color: '',
      m_dist : 0,
      m_area : 0,
      usage  : '',
      pos_x  : this.get_position(),
      active : false
    };
    
    this.clean_tool      = this.clean_tool.bind(this);
    this.fix_draw_titles = this.fix_draw_titles.bind(this);
    this.set_position    = this.set_position.bind(this);
    this.stop_drawing    = this.stop_drawing.bind(this);
    this.activate_tool   = this.activate_tool.bind(this);
    this.close           = this.close.bind(this);
    
    props.app.medidas = this;
  }
  
  
  
  componentWillUnmount() {
    this.props.app.medidas = null;
    
    this.destroy();
  }
  
  
  
  componentDidUpdate(prevProps: T_MedidasProps, prevState: T_MedidasState) {
    if (this.props.width     !== prevProps.width  ||
        this.props.show_tree !== prevProps.show_tree) {
      this.set_position();
    }
    
    if (this.state.m_value === 0 && this.props.app.escala_lyr != null) {
      this.props.app.escala_lyr.setState({smile_on: NaN});
    }
    
    const used = this.state.m_lat || this.state.m_lon || this.state.m_value !== 0 || this.state.m_dist !== 0 || this.state.m_area !== 0;
    
    if (this.props.app.state.show_dialog_tools && used) {
      if (this.state.m_value !== 0 && this.state.m_value !== prevState.m_value) {
        const snum = gen_snum(this.props.num_decimals);
        
        this.props.app.setState({
          result_measure: {
            kind1  : 'pixel',
            result1: S.strip(`${snum(this.state.m_value)} ${this.state.m_units}`),
            kind2  : 'coord',
            result2: `${this.state.m_lat}, ${this.state.m_lon}`
          }
        });
      }
      else if (this.state.m_value === 0 && 
               ((this.state.m_lat !== '' && this.state.m_lat !== prevState.m_lat) ||
                (this.state.m_lon !== '' && this.state.m_lon !== prevState.m_lon))) {
        this.props.app.setState({
          result_measure: {
            kind1  : 'coord',
            result1: `${this.state.m_lat}, ${this.state.m_lon}`,
            kind2  : 'none',
            result2: ''
          }
        });
      }
      else if (this.state.m_dist !== 0 && this.state.m_dist !== prevState.m_dist) {
        const snum = gen_snum(this.props.num_decimals),
              in_km = this.state.m_dist > 1000;
        
        this.props.app.setState({
          result_measure: {
            kind1  : 'dist',
            result1: snum(in_km ? this.state.m_dist / 1000 : this.state.m_dist) + (in_km ? ' km' : ' m'),
            kind2  : 'none',
            result2: ''
          }
        });
      }
      else if (this.state.m_area !== 0 && this.state.m_area !== prevState.m_area) {
        const snum = gen_snum(this.props.num_decimals);
        
        this.props.app.setState({
          result_measure: {
            kind1  : 'area',
            result1: `${snum(this.state.m_area)} has`,
            kind2  : 'none',
            result2: 'none'
          }
        });
      }
    }
    
    if (! this.state.active) {
      if (used) {
        this.activate_tool();
      }
    }
    else {
      if ((! used) && this.props.app.toolbar != null && (! this.props.app.toolbar.state.use_tools)) {
        this.turn_off_tool();
      }
    }
  }
  
  
  
  destroy(): void {
    if (this.drawing_listener != null) {
      this.drawing_listener.remove();
    }
    
    this.drawingManager = null;
    
    this.props.app.medidas = null;
  }
  
  
  
  setup_draw(): void {
    if (this.drawingManager) {
      return;
    }
    
    if (Map.google != null) {
      const google_maps = Map.google;
      
      this.drawingManager = new google_maps.drawing.DrawingManager({
        drawingControlOptions: {
          position: (this.props.hide ? google_maps.ControlPosition.BOTTOM_CENTER : google_maps.ControlPosition.TOP_CENTER),
          drawingModes: ['marker', 'polyline', 'polygon']
        },
        polylineOptions: {geodesic: true},
        polygonOptions: {geodesic: true}
      });
      
      this.drawingManager.setMap(this.props.app.map_ui.map.map);
      
      this.drawing_listener = google_maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
        this.clean_tool(false);
        this.tool_ov = event.overlay;
        
        if (event.type === 'marker') {
          this.pixel_value(event.overlay.getPosition().toJSON());
        }
        else if (event.type === 'polyline') {
          this.set_medidas({
            m_dist: google_maps.geometry.spherical.computeLength(event.overlay.getPath())
          });
        }
        else if (event.type === 'polygon') {
          this.set_medidas({
            m_area: google_maps.geometry.spherical.computeArea(event.overlay.getPath()) / 10000
          });
        }
      });
      
      setTimeout(this.fix_draw_titles, 1500);
    }
  }
  
  
  
  clean_tool(state_too: boolean = true, show_usage: boolean = false): void {
    if (this.tool_ov != null) {
      this.tool_ov.setMap(null);
    }
    
    if (state_too) {
      this.set_medidas(show_usage ? {usage: 'Haga doble click para completar el dibujo'} : {});
    }
  }
  
  
  
  clean_pixel_tool(): void {
    if (this.state.m_value) {
      this.setState({m_value: 0, m_units: ''}, this.set_position);
    }
  }
  
  
  
  // pixel_value -> img-pixel-value (node) -> ImgPixelValue (exec) -> jsonGetPixelValue (hs) -> json.
  
  pixel_value(ll: T_LL): void {
    const {app}       = this.props,
          png_path    = app.map_ui.map.img_that_contains(ll),
          tool_output = {m_lat: dec6(round6(ll.lat)), m_lon: dec6(round6(ll.lng)), m_value: 0, m_units: '', m_color: ''};
    
    if (this.props.use_pixel_tool && png_path != null && app.toolbar != null) {
      const png_file = takeFilename(png_path),
            dir      = takeDir(png_path);
      
      load_stats(app, app.map_ui.map.last_shp_path(), false, false, true, (ss) => {
        const st  = ss.filter(st => st.png === png_file),
              tif = st.length > 0 ? `${dir}/${st[0].tif}` : '',
              ses = app.session(),
              url = `${app.remote}/get-culti-of-dir/?session_id=${ses}&dir=${dir}&param1=ll_bounds_plus_utm_zone`;
        
        fetch(url).then(resp => resp.json()).then((data: T_Bounds) => {
          const unum   = parseInt(data.utm_zone, 10),
                minu   = utm.fromLatLon(data.min_bound[0], data.min_bound[1], unum),    // en utm, si vamos al norte Y aumenta.
                maxu   = utm.fromLatLon(data.max_bound[0], data.max_bound[1], unum),    // En una img, Y disminuye.
                clicku = utm.fromLatLon(ll.lat, ll.lng, unum),
                prop_x = proporcion(minu.easting , maxu.easting , clicku.easting),      // <- AL DERECHO
                prop_y = proporcion(maxu.northing, minu.northing, clicku.northing);     // <- AL REVÉS.
          
          if ((0 <= prop_x && prop_x <= 1) && (0 <= prop_y && prop_y <= 1)) {    // click inside shape bounds
            get_tif_pixel(app, tif, ll.lng, ll.lat, (value) => {
              if (typeof value === 'number') {
                tool_output.m_value = value;
                
                if (takeFilename(tif).toLowerCase().indexOf('nitrosense') === 0) {
                  tool_output.m_value -= 1000;
                }
                
                if (app.map_ui.state.escala_for && app.map_ui.map.Img_List[app.map_ui.state.escala_for].obj.lyr) {
                  tool_output.m_units = no_parens(app.map_ui.map.Img_List[app.map_ui.state.escala_for].obj.lyr.units);
                }
                
                if (app.escala_lyr != null) {
                  const {escala_lyr} = app;
                  
                  escala_lyr.setState({smile_on: value});
                  
                  if (escala_lyr.table != null) {
                    tool_output.m_color = escala_lyr.table.get_color_of(value);
                  }
                }
              }
              else {
                console.error(`get_tif_pixel: ${value}`);
              }
              
              this.set_medidas(tool_output);
            });
          }
          else {
            console.log('fuera del extent del culti', prop_x, prop_y);
            
            this.set_medidas(tool_output);
          }
        });
      });
    }
    else {
      this.set_medidas(tool_output);
    }
  }
  
  
  
  stop_drawing() : void {
    this.setState({active: false});
    
    if (! this.props.hide) {
      this.props.app.bar.show_tools();
    }
  }
  
  
  
  activate_tool(next?: T_Next): void {
    this.setState({active: true}, () => {
      this.set_position();
      
      if (! this.props.hide) {
        this.props.app.bar.hide_tools();
      }
      
      if (next) {
        next(true);
      }
    });
  }
  
  
  
  turn_off_tool(next?: T_Next): void {
    this.setState({active: false}, () => {
      if (! this.props.hide) {
        this.props.app.bar.show_tools();
      }
      
      if (next) {
        next(true);
      }
    });
  }
  
  
  
  hide(): void {
    if (this.j_stop != null) {
      this.j_stop.parent().parent().hide();
    }
    else {
      setTimeout(this.hide, 100);
    }
  }
  
  
  
  show(): void {
    if (this.j_stop != null) {
      this.j_stop.parent().parent().show();
    }
    else {
      setTimeout(this.show, 100);
    }
  }
  
  
  
  fix_draw_titles(): void {
    const divs = $('div.gmnoprint > div');
    
    if (! divs.length) {
      setTimeout(this.fix_draw_titles, 50);
      return;
    }
    
    const {app} = this.props;
    
    divs.each((num: number, el: Element) => {
      $(el).children().each((jj: number, xx: any) => {
        const dt = (xx : T_Title),
              tt = dt.title;
        
        let show_usage = false;
        
        if (tt === 'Dejar de dibujar' || tt === 'Stop drawing') {
          dt.title = 'Desactivar herramienta';
          
          this.raw_stop_bt = $(xx);
          
          $(dt).click(this.stop_drawing);
          
          this.j_stop = $(dt);
        }
        else if (tt === 'Añadir marcador' || tt === 'Añadir un marcador' || tt === 'Add a marker') {
          dt.title = 'Valor del elemento';
          
          $(dt).click(() => this.activate_tool());
          
          this.j_coord = $(dt);
        }
        else if (tt === 'Dibujar línea' || tt === 'Trazar una línea' || tt === 'Draw a line') {
          dt.title = 'Distancia';
          show_usage = true;
          
          $(dt).click(() => this.activate_tool());
          
          this.j_dist = $(dt);
        }
        else if (tt === 'Dibujar forma' || tt === 'Trazar una forma' || tt === 'Draw a shape' || tt === 'Área') {
          dt.title = 'Área';
          show_usage = true;
          
          $(dt).click(() => this.activate_tool());
          
          this.j_area = $(dt);
        }
        
        $(dt).click(() => {
          if (app.medidas) {
            app.medidas.clean_tool(true, show_usage);
          }
        });
      });
    });
    
    if (this.props.hide) {
      this.hide();
    }
  }
  
  
  
  get_position(): number {
    const offset = SIDEBAR_WIDTH;
    
    let rw = (this.props.width - offset - 2) / 2;
    
    const dll = $('.divLLVal');
    
    if (dll.length) {
      rw = rw - (dll.width() / 2);
    }
    
    return offset + rw;
  }
  
  
  
  set_position(): void {
    this.setState({
      pos_x: this.get_position()
    });
  }
  
  
  
  set_medidas(medidas: Object): void {
    const new_state: T_MedidasState = {
      m_lat  : '',
      m_lon  : '',
      m_value: 0,
      m_units: '',
      m_color: '',
      m_dist : 0,
      m_area : 0,
      usage  : '',
      pos_x  : this.state.pos_x,
      active : this.state.active
    };
    
    this.setState(_.extend(new_state, medidas), this.set_position);
  }
  
  
  
  close(): void {
    this.set_medidas({});
    
    if (this.raw_stop_bt != null) {
      this.raw_stop_bt.click();
    }
  }
  
  
  
  is_active(): boolean {
    return this.state.active && (
      this.state.m_lat !== '' || this.state.m_lon !== '' || this.state.m_value !== 0 ||
      this.state.m_dist !== 0 || this.state.m_area !== 0
    );
  }
  
  
  
  render() {
    let bg_color = '#444',
        uso_cls  = 'uso_medida';
    
    const snum  = gen_snum(this.props.num_decimals),
          in_km = this.state.m_dist > 1000;
    
    if (this.state.m_color !== '') {
      bg_color = this.state.m_color;
    }
    
    if (this.props.hide) {
      uso_cls += ' uso_medida_float';
    }
    
    return (
      <div className='divLLVal' style={{left: this.state.pos_x}} onContextMenu={no_rclick}>
        {(this.state.m_lat && this.state.m_lon && ! this.props.hide) &&
          <Chip>
            <Avatar backgroundColor='Violet' color='#444' icon={<ActionLanguage />} />
            {this.state.m_lat}, {this.state.m_lon}
          </Chip>
        }

        {(this.state.m_value !== 0 && ! this.props.hide) &&
          <Chip style={{marginLeft: 10}}>
            <Avatar backgroundColor={bg_color} color={invertColor(bg_color)} icon={<ImageColorize />} />
            {snum(this.state.m_value)}
            
            {(this.state.m_units !== '') &&
              <span style={{marginLeft: 4}}>
                {this.state.m_units}
              </span>
            }
          </Chip>
        }
        
        {(this.state.m_dist !== 0 && ! this.props.hide) &&
          <Chip>
            <Avatar backgroundColor='Violet' color='#444' icon={<ImageStraighten color='#ffffff' />} />
            {snum(in_km ? this.state.m_dist / 1000 : this.state.m_dist) + (in_km ? ' km' : ' m')}
          </Chip>
        }
        
        {this.state.usage &&
          <span className={uso_cls}>
            {this.state.usage}
          </span>
        }
        
        {(this.state.m_area !== 0 && ! this.props.hide) &&
          <Chip>
            <Avatar backgroundColor='Violet' color='#444' icon={<DeviceSignalCellularNull />} />
            {`${snum(this.state.m_area)} has`}
          </Chip>
        }
        
        {(this.is_active() && ! this.props.hide) &&
          <button className='close_med' onClick={this.close}>
            <Icon name='close' inverse={true} />
          </button>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Medidas.jsx